import script from "./addialog.vue?vue&type=script&setup=true&lang=js"
export * from "./addialog.vue?vue&type=script&setup=true&lang=js"

import "./addialog.vue?vue&type=style&index=0&id=512ebee3&lang=less"

const __exports__ = script;

export default __exports__